module.exports = __webpack_public_path__ + "img/BASYS_Logo_Secondary.042b9cc3.png";